import AWS from "aws-sdk";

console.log("-->env Bucket: ", process.env.REACT_APP_S3_BUCKET);
const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const REGION = process.env.REACT_APP_REGION;
const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY;

AWS.config.update({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});
const S3 = new AWS.S3({
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});

export const upload_file_to_s3 = async (file, onProgress) => {
  console.log("-- file type: ", file.type);
  const params = {
    ACL: "public-read",
    Bucket: S3_BUCKET,
    //Key: file.name,
    Key: "" + new Date().getTime(),
    Body: file,
    ContentType: file.type,
  };

  return new Promise((resolve, reject) => {
    const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
    S3.upload(params, options, (err, data) => {
      if (err) {
        reject(err);
      } else {
        resolve(data.Location); // Resolving with the S3 URL
      }
    }).on("httpUploadProgress", (progress) => {
      const uploadedBytes = progress.loaded;
      const totalBytes = progress.total;

      const uploadPercentage = Math.round((uploadedBytes / totalBytes) * 100);

      onProgress(uploadPercentage); // Calling the progress callback with the percentage
    });
  });
};

export const delete_file_from_s3 = async (filename) => {
  const params = {
    Bucket: S3_BUCKET,
    Key: filename,
  };
  return new Promise((resolve, reject) => {
    S3.deleteObject(params, async (err, data) => {
      if (err) {
        console.log("Error deleting file:" + err);
        reject(err);
      } else {
        console.log("File deleted successfully:" + filename);
        resolve({ status: "success" });
      }
    });
  });
};
